/* eslint-disable complexity */
import React, { useContext, useState, useEffect } from 'react'
import PageLoader from 'Lib/Pageloader'
import {
  updateOptionsLevel,
  checkMobileDevice,
  getCommonClevertapParams,
  triggerClevertap,
  htmlDecoder,
  formatDate,
  removeSpacesAndCapitalize
} from 'AccountsUtils'
import { isInFlyinDomain } from 'AccountsUtils'

import { donwloadPDFwithByteCode } from 'AccountsUtils/common'
import { AccountsContext } from 'AccountsContext'
import TripLabel from '../TripLabel'
import BaggageInfo from '../BaggageInfo'
import AirlineInfo from '../AirlineInfo'
import './OptionsBox.css'
import Modal from '../Modal/index'

const InputComponent = ({ ele, idx, handleChange }) => {
  const [inputValue, setInputValue] = useState(ele.value)
  const updateValue = value => {
    setInputValue(value)
    handleChange(value, idx)
  }
  return (
    <div className="d-flex flex-between inputPopUpContainer">
      <label className="mt-5px">{ele.tag}:</label>
      <input
        value={inputValue}
        type={ele.type}
        placeholder={ele.tag}
        onChange={e => { updateValue(e.target.value) } }
      />
    </div>
  )
}

const InputPopUpModal = ({ data, getData, errorMessage }) => {
  const inputData = []
  const handleChange = (value, idx) => {
    inputData[idx] = value
    getData(inputData)
  }
  return (
    <div>
      {data.inputTypeFields.map((ele, idx) => {
        return (
          <InputComponent ele={ele} idx={idx} handleChange={handleChange} />
        )
      })}
      {errorMessage !== '' && <p className="inputPopUp_err">{errorMessage}</p>}
    </div>
  )
}

const OptionsBox = () => {
  const [inputPopUpResponse, setInputPopUpResponse] = useState([])
  const [tripOptionsDataNew, setTripOptionsDataNew] = useState({})
  const [inputPopUpError, setInputPopUpError] = useState('')
  const [pageIsLoading, setPageIsLoading] = useState(false)
  const {
    fetchAllTrips,
    tripListAPIData,
    showLoadMore,
    tripOptionsData,
    trips,
    tripOptionsAPIData,
    updateTripOptionsAPIData,
    fetchOptions,
    updateTripOptions,
    showTripList,
    updateShowFlagForTripList,
    updateSelectedIssue,
    previousStepOptionsData,
    previousOptionsAPIData,
    updatePreviousOptionsAPIData,
    loading,
    loadingFailed,
    updateFlagToShowSupportNumbers,
    selectedTrip,
    fetchDetailsOfSelectedTrip,
    updateWidgetContainerClasses,
    detailsPageInvalid,
    modalMessage,
    modalTitle,
    isTripOptionsNew,
    initialNewTreeData
  } = useContext(AccountsContext)
  const newDataFlag = isTripOptionsNew
  const fetchInitialNewOptions = () => {
    if (window.location.pathname !== '/accounts/trips') {
      setPageIsLoading(true)
    }
    setTripOptionsDataNew(initialNewTreeData)
    setPageIsLoading(false)
  }
  useEffect(() => {
    if (selectedTrip.showNewTree === undefined) {
      if (window.location.pathname !== '/accounts/trips') {
        setPageIsLoading(true)
      }
    } else {
      setPageIsLoading(false)
    }
    if (selectedTrip.showNewTree === true) {
      setTripOptionsDataNew(initialNewTreeData)
    }
  }, [selectedTrip])
  useEffect(() => {
    setTripOptionsDataNew(initialNewTreeData)
  }, [initialNewTreeData])
  const getExpiredTrips = () => {
    fetchAllTrips(tripListAPIData)
  }
  const triggerClevertapEvent = event_name => {
    const cleverTapData = { ...getCommonClevertapParams() }
    cleverTapData.trip_ID = selectedTrip.tripId
    cleverTapData.trip_status = selectedTrip ? selectedTrip.bookingStatus : ''
    cleverTapData.product = selectedTrip ? selectedTrip.verticalName : ''
    cleverTapData.action_name = 'self_serve_options_click'
    cleverTapData.action_value = event_name
    triggerClevertap('Account_UI_Action', cleverTapData)
  }
  const buildHistory = (history, option) => {
    let newHistory = [...history]
    if (option === 'BACK_ACTION') {
      newHistory.pop()
      newHistory.pop()
    } else {
      newHistory = history
    }
    if (newHistory?.length === 0 || newHistory === undefined) {
      return []
    }
    return newHistory
  }

  const getBackActionTag = history => {
    if (history === null) {
      fetchInitialNewOptions()
      return
    }
    if (history.length >= 2) {
      return history[history.length - 2]
    }
    return history[history.length - 1]
  }
  const fetchUpdatedOptionListNew = opt => {
    // API to add event listners

    // API to get new options

    triggerClevertapEvent(opt.tag)
    if (window.location.pathname !== '/accounts/trips') {
      setPageIsLoading(true)
    }
    const payload = {
      tripId: selectedTrip.tripId,
      menuClicked: opt.tag === 'BACK_ACTION' ? getBackActionTag(tripOptionsDataNew.menusClickedHistory) : opt.tag,
      menusClickedHistory: buildHistory(tripOptionsDataNew.menusClickedHistory, opt.tag)
    }
    fetchOptions(payload, newDataFlag, false, res => {
      if (res?.actionResponsesUI === null) {
        setTripOptionsDataNew(res)
      } else if (res?.actionResponsesUI?.actionType === 'REDIRECT') {
        window.location.href = res.actionResponsesUI?.redirectTo
      } else if (res?.actionResponsesUI &&
        res?.actionResponsesUI?.actionType === 'DOWNLOAD_ACTION') {
        donwloadPDFwithByteCode(res.actionResponsesUI.byteCode, res.actionResponsesUI.fileName)
        setTripOptionsDataNew(res)
      } else {
        setTripOptionsDataNew(res)
      }
      setPageIsLoading(false)
    })
  }
  const getHeaderMessage = message => {
    const messageArray = message?.message?.split('\n')
    if (message && messageArray) {
      return (
        <ul className="br-1-white">
          {
            messageArray.map(ele => {
              return <li className="fs-13 mb-0 mt-0 apl-15 apr-15 apt-5 apb-5 issue_block_header">{ele}</li>
            })
          }
        </ul>
      )
    }
  }
  const fetchUpdatedOptionList = option => () => {
    if (option.type && option.type === 'back') {
      updateTripOptionsAPIData(previousOptionsAPIData[tripOptionsAPIData.level])
      updateTripOptions(previousStepOptionsData[tripOptionsAPIData.level])
      return
    }
    if (tripOptionsAPIData.level === 'L1') {
      updateSelectedIssue({
        label: 'Selected Issue',
        value: option.value,
        visible: true
      })
    }
    const payload = tripOptionsAPIData
    const prev = { ...previousOptionsAPIData }
    const levelObj = { ...tripOptionsAPIData }
    prev[updateOptionsLevel(levelObj.level)] = { ...tripOptionsAPIData }
    updatePreviousOptionsAPIData(prev)
    payload.tripType = tripOptionsData.tripType || tripOptionsAPIData.tripType
    payload[tripOptionsAPIData.level.toLowerCase()] = option.value
    payload.level = updateOptionsLevel(tripOptionsAPIData.level)
    updateTripOptionsAPIData(payload)
    if (option.pathVariable) {
      payload.pathVariable = tripOptionsAPIData[option.pathVariable]
    }
    if (option &&
      option.params &&
      option.params.length) {
      payload.params = {}
      for (const param of option.params) {
        const val = removeSpacesAndCapitalize(option.value)
        payload.params[param] = val && val.toLowerCase() === 'myplanschangedduetocoronavirus' ? 'DueToCoronavirus' : val
      }
    }
    fetchOptions(payload, selectedTrip.showNewTree)
    const clevertapData = { ...getCommonClevertapParams() }
    clevertapData.trip_ID = `${selectedTrip.tripId}`
    clevertapData.trip_status = selectedTrip.bookingStatus
    clevertapData.product = selectedTrip.verticalName
    clevertapData[`${tripOptionsAPIData.level}_menu`] = option.value
    clevertapData.dom_intl = selectedTrip.tripType === 'D' ? 'dom' : 'intl'
    if (selectedTrip && selectedTrip.flightDetails && selectedTrip.flightDetails.length > 0) {
      selectedTrip.flightDetails.forEach(flight => {
        const { flightArrivalAirport, flightDepartureAirport, segmentDetails } = flight
        clevertapData.source_airport = clevertapData.source_airport ? `${clevertapData.source_airport}, ${flightDepartureAirport}` : ''
        clevertapData.dest_airport = clevertapData.dest_airport ? `${clevertapData.dest_airport}, ${flightArrivalAirport}` : ''
        if (segmentDetails && segmentDetails.length > 0) {
          segmentDetails.forEach(segment => {
            const { operatingAirline, departureAirport, arrivalAirport } = segment
            clevertapData.airline = clevertapData.airline ? `${clevertapData.airline}, ${operatingAirline}` : ''
            const sector = `${departureAirport}-${arrivalAirport}`
            clevertapData.sector = clevertapData.sector ? `${clevertapData.sector},${sector}` : ''
          })
        }
      })
    }
    const lev = parseInt(payload.level.charAt(1), 10)
    for (let index = 0; index < lev; index += 1) {
      clevertapData[`l${index}`] = payload[`l${index}`]
    }
    clevertapData.event_type = 'support_issue_selection'
    triggerClevertap('Account', clevertapData)
  }

  const fetchInitialOptionsList = id => () => {
    const payload = {
      tripId: id,
      level: 'L1'
    }
    const cleverTapData = getCommonClevertapParams()
    cleverTapData.trip_ID = `${id}`
    cleverTapData.trip_status = selectedTrip ? selectedTrip.bookingStatus : ''
    cleverTapData.product = selectedTrip ? selectedTrip.verticalName : ''
    triggerClevertap('support_trip_selection', cleverTapData)
    fetchDetailsOfSelectedTrip(id, payload)
    updateShowFlagForTripList(false)
    updateTripOptionsAPIData(payload)
    // fetchOptions(payload)
  }
  const renderOptionsHeader = () => {
    if (showTripList) {
      return ['Select your booking']
    }
    if (tripOptionsAPIData.l1 === 'Baggage Allowance' || tripOptionsAPIData.l2 === 'Airline GST Invoice') {
      if (tripOptionsData.message && tripOptionsData.message.indexOf('$$') > -1) {
        return tripOptionsData.message.split('$$').reverse()
      }
      return [tripOptionsData.message, '']
    }
    if (tripOptionsData.message && tripOptionsData.message.indexOf('##') > -1) {
      let parts = tripOptionsData.message.split('##')
      parts = parts.reduce((init, item) => {
        let newInit = init
        if (item.indexOf('>>') > -1) {
          const [text, href] = item.split('>>')
          newInit = newInit.concat([<a href={href} className="c-blue px-1">{text}</a>])
        } else if (item && item.indexOf('>>') === -1) {
          newInit = newInit.concat([item])
        }
        return newInit
      }, [])
      return parts
    }
    if (tripOptionsData.message && tripOptionsData.message.indexOf('$$') > -1) {
      return tripOptionsData.message.split('$$').reverse()
    }
    if (tripOptionsData.message && tripOptionsData.message.indexOf('%%') > -1) {
      return [formatDate(tripOptionsData.message)]
    }
    return [tripOptionsData.message]
  }

  const goBackToTrips = () => {
    window.location.href = checkMobileDevice() 
    ? isInFlyinDomain() 
      ? '/m/accounts/trips?chnl=Fly' 
      : '/m/accounts/trips' 
    : isInFlyinDomain() 
      ? '/accounts/trips?chnl=Fly' 
      : '/accounts/trips'
  }
  const gotopreviousmenu = () => {
    fetchUpdatedOptionListNew({
      tag: 'BACK_ACTION'
    })
  }
  const setInputPopUpData = value => {
    setInputPopUpResponse(value)
  }
  const handleInputSubmit = data => {
    let reqData = {}
    setInputPopUpError('')
    let flag = false
    tripOptionsDataNew.inputPopupData.inputTypeFields.forEach((ele, idx) => {
      reqData[`${ele.tag}`] = inputPopUpResponse[idx]
      if (ele.tag === 'phoneNumber' || ele.tag === 'Mobile') {
        if (inputPopUpResponse[idx] && inputPopUpResponse[idx].length !== 10) {
          flag = true
          setInputPopUpError('Please enter a valid mobile number')
        }
      }
    })
    if (!flag) {
      reqData = {
        ...reqData,
        ...data.additionalData
      }
      const payload = {
        tripId: selectedTrip.tripId,
        menuClicked: '',
        buttonClicked: data.name,
        menusClickedHistory: tripOptionsDataNew.menusClickedHistory,
        additionalParams: reqData
      }
      if (window.location.pathname !== '/accounts/trips') {
        setPageIsLoading(true)
      }
      fetchOptions(payload, newDataFlag, true, res => {
        setTripOptionsDataNew(res)
        setPageIsLoading(false)
      })
    }
  }
  let optionsView = null
  if (((tripOptionsData &&
    tripOptionsData.supportDisplayOptions &&
    tripOptionsData.supportDisplayOptions.length &&
    !showTripList) ||
    (showTripList &&
      trips &&
      trips.length)) &&
    !loading && !loadingFailed
  ) {
    optionsView = (
      <>
        <If condition={pageIsLoading}><PageLoader title="Loading..." message="Please wait..." /></If>
        <If condition={newDataFlag && tripOptionsDataNew?.actionResponsesUI?.actionType === 'inputPopup'}>
          <Modal
            header={tripOptionsDataNew?.inputPopupData.header}
            content={(
              <InputPopUpModal
                data={tripOptionsDataNew?.inputPopupData}
                getData={setInputPopUpData}
                errorMessage={inputPopUpError}
              />
            )}
            secondaryButton={{
              visible: tripOptionsDataNew?.inputPopupData.buttons[1]?.name || false,
              text: tripOptionsDataNew?.inputPopupData.buttons[1]?.name,
              action: () => {
                if (tripOptionsDataNew?.inputPopupData.buttons[1]?.type === 'close')gotopreviousmenu()
                else if (tripOptionsDataNew?.inputPopupData.buttons[1]?.type === 'action') {
                  handleInputSubmit(tripOptionsDataNew?.inputPopupData.buttons[1])
                }
              }
            }}
            primaryButton={{
              visible: tripOptionsDataNew?.inputPopupData.buttons[0]?.name || false,
              text: tripOptionsDataNew?.inputPopupData.buttons[0]?.name,
              action: () => {
                if (tripOptionsDataNew?.inputPopupData.buttons[0]?.type === 'close')gotopreviousmenu()
                else if (tripOptionsDataNew?.inputPopupData.buttons[0]?.type === 'action')handleInputSubmit(tripOptionsDataNew?.inputPopupData.buttons[0])
              }
            }}
            closeAction={gotopreviousmenu}
          />
        </If>
        <If condition={newDataFlag && tripOptionsDataNew?.actionResponsesUI?.actionType === 'DOWNLOAD_ACTION' ||
            tripOptionsDataNew?.actionResponsesUI?.actionType === 'popup' ||
            tripOptionsDataNew?.actionResponsesUI === null
        }
        >
          <Modal
            header={tripOptionsDataNew?.actionResponsesUI.popupHeader || ''}
            content={(
              tripOptionsDataNew.actionResponsesUI?.message.map(ele => {
                return <p>{ele.message}</p>
              })
            )}
            secondaryButton={{
              visible: false,
            }}
            primaryButton={{
              visible: false,
            }}
            closeAction={gotopreviousmenu}
          />
        </If>

        <div className="options-box">
          <If
            condition={selectedTrip !== null &&
            typeof selectedTrip === 'object' &&
            Object.keys(selectedTrip).length > 0 &&
            tripOptionsAPIData &&
            (tripOptionsAPIData.level === 'L1' ||
              (tripOptionsAPIData.l1 &&
                ['cancellation charges', 'modify booking'].indexOf(tripOptionsAPIData.l1.toLowerCase()) !== -1)) &&
              false}
          />
          <If condition={!selectedTrip.showNewTree}>
            <div className="options-box-header fw-500 fs-14 pl-0 pr-0">
              <If condition={tripOptionsData.message && tripOptionsData.message.indexOf('##') === -1}>
                <If condition={renderOptionsHeader().length > 1 || (tripOptionsData &&
                tripOptionsData.airlineInfo &&
                tripOptionsData.airlineInfo.length) || (tripOptionsData &&
                  tripOptionsData.baggages &&
                  tripOptionsData.baggages.length)}
                >
                  <div className="mb-0 mt-0 apl-15 apr-15 lh-title extra-info">
                    {htmlDecoder(renderOptionsHeader()[1])}
                    <If condition={tripOptionsData &&
                    tripOptionsData.airlineInfo &&
                    tripOptionsData.airlineInfo.length}
                    >
                      <AirlineInfo info={tripOptionsData.airlineInfo} />
                    </If>
                    <If condition={tripOptionsData &&
                    tripOptionsData.baggages &&
                    tripOptionsData.baggages.length}
                    >
                      <BaggageInfo baggages={tripOptionsData.baggages} />
                    </If>
                  </div>
                </If>
                <p className="fs-13 mb-0 mt-0 apl-15 apr-15 apt-5 apb-5 issue_block_header">
                  {htmlDecoder(renderOptionsHeader()[0])}
                </p>
                <Else />
                <div className="flex">
                  <p className="fs-13 mb-0 mt-0 apl-15 apr-15 apt-5 apb-5 issue_block_header">
                    {renderOptionsHeader()}
                  </p>
                </div>
              </If>
            </div>
          </If>
          <If
            condition={newDataFlag && tripOptionsDataNew?.actionResponsesUI?.actionType === 'menuMessage'
            }
          >
            <div className="options-box-header fw-500 fs-14 pl-0 pr-0">
              <If condition={tripOptionsDataNew?.actionResponsesUI?.message &&
                tripOptionsDataNew?.actionResponsesUI?.message.length > 0}
              >
                <div>
                  {tripOptionsDataNew?.actionResponsesUI?.message &&
                  tripOptionsDataNew?.actionResponsesUI?.message.map(message => {
                    return getHeaderMessage(message)
                  })
                  }
                </div>
              </If>
              <p className="fs-13 mb-0 mt-0 apl-15 apr-15 apt-5 apb-5 issue_block_header">
                {tripOptionsDataNew?.actionResponsesUI?.menuMessage}
              </p>
            </div>
          </If>

          <ul className="issue-list pl0 pr0 mb0 mt0 pb0">
            <If condition={!showTripList && !selectedTrip.showNewTree &&
              tripOptionsData?.supportDisplayOptions}
            >
              {
                tripOptionsData?.supportDisplayOptions.map((opt, index) => {
                  return (
                    <li
                      className="option-box-item bg-white apl-15 apt-15 apr-15 apb-15"
                      onClick={fetchUpdatedOptionList(opt)}
                    >
                      {opt.value}
                    </li>
                  )
                })
              }
            </If>
            <If condition={!showTripList && newDataFlag &&
            tripOptionsDataNew?.actionResponsesUI?.actionType === 'menuMessage'}
            >
              {
                tripOptionsDataNew?.supportDisplayOptions.map((opt, index) => (
                  <li
                    className="option-box-item bg-white apl-15 apt-15 apr-15 apb-15"
                    onClick={e => fetchUpdatedOptionListNew(opt)}
                  >
                    {opt.name}
                  </li>
                ))
              }
            </If>
            <If condition={showTripList}>
              {
                trips.map((trip, index) => {
                  return (
                    <li
                      className="option-box-item bg-white"
                      onClick={fetchInitialOptionsList(trip.tripId)}
                    >
                      <TripLabel tripDetails={trip} />
                    </li>
                  )
                })
              }
            </If>
          </ul>
          <If condition={showLoadMore}>
            <div className="pagination-button" onClick={getExpiredTrips}> See more bookings </div>
          </If>
        </div>

      </>
    )
  } else if (detailsPageInvalid && !loading && !loadingFailed) {
    const invalidDetailsMessage = 'The details of this trip cannot be viewed at the moment.If you need help with any other trip, click'
    const invalidDetailsTitle = 'Sorry, unable to get your details right now.'
    const displayModalMsg = msgs => {
      let returnVal = msgs
      if (typeof msgs === 'object' && msgs.length > 0) {
        returnVal = (
          msgs.map(msg => (
            <>
              <div>{msg}</div>
            </>
          ))
        )
      }
      return returnVal
    }
    optionsView = (
      <div className="ta-c no-trips">
        <svg width="34" height="34" viewBox="0 0 18 16" xmlnsXlink="http://www.w3.org/1999/xlink" fill="#FFBA00">
          <defs>
            <path id="warning-a" d="M10.969 9.136h2.062v5.606H10.97V9.137zm0 7.01h2.062v1.868H10.97v-1.869zm9.948 2.783L12.566 4.325A.649.649 0 0 0 12 4a.65.65 0 0 0-.566.325l-8.35 14.604a.626.626 0 0 0 .004.636c.118.196.33.317.561.317h16.702c.23 0 .442-.121.56-.317a.631.631 0 0 0 .006-.636z" />
          </defs>
          <use fillRule="evenodd" xlinkHref="#warning-a" transform="translate(-3 -4)" />
        </svg>
        <div className="fs-16 apl-20 apr-20 amt-10 mt10">
          {modalTitle !== '' ? modalTitle : invalidDetailsTitle}
        </div>
        <div className="fs-13 apl-20 apr-20 amt-10 mt10 c-black-50 lh-title">
          {modalMessage !== '' && modalMessage.length !== 0 ? displayModalMsg(modalMessage) : invalidDetailsMessage}
        </div>
        <a className="book-redirect-link" onClick={goBackToTrips}>Back to trips</a>
      </div>
    )
  } else if (showTripList && trips && trips.length === 0 && !loading && !loadingFailed) {
    optionsView = (
      <div className="ta-c no-trips">
        <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="36px" height="36px" viewBox="0 0 24 19" fill="#36c">
          <defs>
            <path id="trips-a" d="M0 17.522V4.432c0-.453.366-.819.818-.819h2.796V18.34H.818A.817.817 0 0 1 0 17.522zM19.977 3.613h3.205c.452 0 .818.366.818.818v13.09a.817.817 0 0 1-.818.819h-3.205V3.613zM4.432 3.611l14.727.002V18.34H4.432V3.61zm3.75-1.975h7.362v1.975H8.182V1.636zm0-1.636c-.904 0-1.637.732-1.637 1.636v1.975h10.636V1.636C17.18.732 16.448 0 15.544 0H8.182z" />
          </defs>
          <use xlinkHref="#trips-a" fillRule="evenodd" />
        </svg>
        <div className="fs-16 apl-20 apr-20 amt-10 mt10">
          There are no bookings under this account.
        </div>
        <div className="fs-13 apl-20 apr-20 amt-10 mt10 c-black-50 lh-title">
          Enjoy the quick and easy booking experience on our website and mobile app
        </div>
        <a href="/flights" className="book-redirect-link">Book tickets</a>
      </div>
    )
  } else if (loading && !loadingFailed) {
    optionsView = (
      <PageLoader
        title="Please wait"
      />
    )
  } else if (!loading && loadingFailed) {
    updateFlagToShowSupportNumbers(true)
    updateWidgetContainerClasses('support-widget-container push-left alertOverlay')
  }
  return optionsView
}

export default OptionsBox
